export default __webpack_public_path__ + "static/media/art.f5a3b52c.svg";